import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type CalendarIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function CalendarIcon({
  className,
  pathClassName = "stroke-black",
  ...props
}: CalendarIconProps) {
  return (
    <Svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M17 5.29H7a4 4 0 00-4 4v8.75a4 4 0 004 4h10a4 4 0 004-4V9.29a4 4 0 00-4-4zM3 10.29h18M17 3.29v4M7 3.29v4"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M9 15.378l1.689 1.689a.639.639 0 00.908 0L15 13.664"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default CalendarIcon;
